import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { TrendingUp, TrendingDown } from "lucide-react";

interface StrategyCardProps {
  type: 'LONG' | 'SHORT' | 'BOTH';
  title: string;
  symbol: string;
  leverage: number;
  entryCount: number;
  entryMultiplier: number;
  entryInterval: number;
  takeProfit: number;
  yield90d: number;
  onSelect?: () => void;
}

export const StrategyCard: React.FC<StrategyCardProps> = ({
  type,
  title,
  symbol,
  leverage,
  entryCount,
  entryMultiplier,
  entryInterval,
  takeProfit,
  yield90d,
  onSelect
}) => {
  const isLong = type === 'LONG';
  const isBoth = type === 'BOTH';
  
  return (
    <Card className="overflow-hidden border-border hover:shadow-lg transition-all duration-300 bg-card">
      <CardHeader className="pb-2">
        <div className="flex justify-between items-start mb-2">
          <Badge className={
            isBoth ? "bg-primary/10 text-primary border-primary/20" :
            (isLong ? "bg-success/10 text-success border-success/20" : "bg-danger/10 text-danger border-danger/20")
          }>
            {type}
          </Badge>
          <div className="flex items-center gap-1 text-muted-foreground text-xs">
            {isBoth ? <TrendingUp className="w-3 h-3 text-primary" /> : (isLong ? <TrendingUp className="w-3 h-3 text-success" /> : <TrendingDown className="w-3 h-3 text-danger" />)}
            {symbol}
          </div>
        </div>
        <CardTitle className="text-lg font-bold text-foreground">
          {title}
        </CardTitle>
      </CardHeader>
      
      <CardContent className="space-y-4 pt-4">
        <div className="grid grid-cols-2 gap-y-3 text-sm">
          <div>
            <span className="text-muted-foreground block text-xs">추천 종목</span>
            <span className="font-semibold text-foreground">{symbol}</span>
          </div>
          <div>
            <span className="text-muted-foreground block text-xs">추천 레버리지</span>
            <span className="font-semibold text-foreground">{leverage}x</span>
          </div>
          <div>
            <span className="text-muted-foreground block text-xs">추가 진입 횟수</span>
            <span className="font-semibold text-foreground">{entryCount}회</span>
          </div>
          <div>
            <span className="text-muted-foreground block text-xs">추가 진입 배율</span>
            <span className="font-semibold text-foreground">{entryMultiplier}배</span>
          </div>
          <div>
            <span className="text-muted-foreground block text-xs">추가 진입 간격</span>
            <span className="font-semibold text-foreground">{entryInterval}%</span>
          </div>
          <div>
            <span className="text-muted-foreground block text-xs">익절</span>
            <span className="font-semibold text-foreground">{takeProfit}%</span>
          </div>
        </div>
        
        {/* <div className="pt-2 border-t border-border flex justify-between items-center">
          <span className="text-sm text-muted-foreground">90일 예상 수익률</span>
          <span className={`text-lg font-bold ${yield90d >= 0 ? 'text-success' : 'text-danger'}`}>
            {yield90d}%
          </span>
        </div> */}
      </CardContent>
      
      <CardFooter>
        <Button 
          onClick={onSelect}
          className="w-full bg-primary text-primary-foreground hover:opacity-90 font-semibold rounded-lg"
        >
          선택 하기
        </Button>
      </CardFooter>
    </Card>
  );
};
